import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const Title = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: ${darkgrey};
`;

export const InningRulesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
